/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { R400 } from '@atlaskit/theme/colors';
import { fontFamily as getFontFamily } from '@atlaskit/theme/constants';
const fontFamily = getFontFamily();
const requiredIndicatorStyles = css({
  paddingLeft: "var(--ds-space-025, 2px)",
  color: `var(--ds-text-danger, ${R400})`,
  fontFamily
});
export default function RequiredAsterisk() {
  return jsx("span", {
    css: requiredIndicatorStyles,
    "aria-hidden": "true",
    title: "required"
  }, "*");
}